// Maturidade da classe = em que ponto do ciclo de vida ela está.
// Derivada SÓ dos campos que já vêm em ClassListItem (sem fetch extra):
// ruleCount + status. "Sem benchmark" / precisão real exigiriam dados de
// benchmark por classe que o GET /classes ainda não traz — ficam pra depois.

import type { ClassListItem } from '../api'

export type MaturityLevel =
  | 'INCOMPLETE'
  | 'READY_FOR_TEST'
  | 'NEEDS_REVIEW'
  | 'PRODUCTION_CANDIDATE'

export interface Maturity {
  level: MaturityLevel
  label: string
  // cor do indicador (classe Tailwind de background do dot)
  dotClass: string
  description: string
}

const MATURITY: Record<MaturityLevel, Omit<Maturity, 'level'>> = {
  INCOMPLETE: {
    label: 'Incompleta',
    dotClass: 'bg-neutral-400',
    description: 'Ainda sem regras — a classe não consegue classificar nada. Adicione sinais e gere regras.',
  },
  READY_FOR_TEST: {
    label: 'Pronta para teste',
    dotClass: 'bg-brand-500',
    description: 'Tem regras configuradas. Rode contra uma base de teste pra medir precisão e cobertura.',
  },
  NEEDS_REVIEW: {
    label: 'Precisa revisão',
    dotClass: 'bg-warning',
    description: 'Em teste — itere nas regras a partir dos falsos positivos/negativos antes de promover.',
  },
  PRODUCTION_CANDIDATE: {
    label: 'Candidata à produção',
    dotClass: 'bg-success',
    description: 'Promovida para produção.',
  },
}

export function classMaturity(c: Pick<ClassListItem, 'ruleCount' | 'status'>): Maturity {
  let level: MaturityLevel
  if (c.ruleCount === 0) level = 'INCOMPLETE'
  else if (c.status === 'PRODUCTION') level = 'PRODUCTION_CANDIDATE'
  else if (c.status === 'TESTING') level = 'NEEDS_REVIEW'
  else level = 'READY_FOR_TEST'
  return { level, ...MATURITY[level] }
}
